<!-- Skip link - accessible navigation bypass -->
<chef-skip-link></chef-skip-link>

<lib-centered-header [options]="headerFooterOptions()"></lib-centered-header>
<!-- Stencil notifications -->
<chef-notification></chef-notification>

<!-- Stencil spinner -->
<chef-spinner></chef-spinner>

<main id="main" class="min-h-screen">
  <router-outlet></router-outlet>
</main>

<!-- Footer -->
<lib-footer [options]="headerFooterOptions()"></lib-footer>

<!-- Stencil back-to-top -->
<chef-back-to-top></chef-back-to-top>
